import React from "react";
import { Container, Grid } from "@material-ui/core";

import Page from "~/components/common/page/Page";
import GroupDriverFinder from "~/components/groupOfDrivers/finder/GroupDriverFinder";
import "./GroupDriverFinderView.scss"


const GroupDriverFinderView = () => {

	return (
		<>
			<Page>
				<main>
					<Container maxWidth="lg" className="containerRegisterGroupDrivers container-map-view">
						<Grid container>
							<Grid item xs={12}>
								<GroupDriverFinder />
							</Grid>
						</Grid>
					</Container>
				</main>
			</Page>
		</>
	);
};

export default GroupDriverFinderView;
